var map = {
	"./Messages.jpg": 325,
	"./Messages.png": 129,
	"./book.png": 130,
	"./box.png": 131,
	"./chat.png": 132,
	"./chat_01.png": 326,
	"./chat_02.png": 327,
	"./chat_icon.png": 328,
	"./cloud.png": 133,
	"./dashboard.png": 329,
	"./dot.png": 330,
	"./get_started_bg.png": 331,
	"./john.png": 134,
	"./left_leaf.png": 135,
	"./live_chat.png": 136,
	"./mobile.png": 137,
	"./panguin_img_one.png": 138,
	"./panguin_img_three.png": 139,
	"./panguin_img_two.png": 140,
	"./pluse.png": 141,
	"./richard.png": 142,
	"./right_leaf.png": 143,
	"./skyp_1.png": 332,
	"./skyp_2.png": 333,
	"./support_dashboard.jpg": 334,
	"./triangle.png": 144,
	"./video_icon.png": 335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;